import styled from '@emotion/styled';

export const HeaderBox = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 1366px;
  height: 80px;
  background: rgba(255, 255, 255, 1);
`;

export const Descriptions = styled.div`
  margin-left: 200px;
  margin-right: 40px;
  & span {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.2;
    color: #37474f;
  }
`;
